// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  color: 'beta',
  base_url: "https://heynowbeta.appspot.com",
  samwise_url: "https://samwise-1087886164575.europe-north1.run.app",
  booking_url: "https://reservation.heynow.dev",
  genji_url: "https://genji-beta-server.appspot.com",
  lingua_url: "https://lingua-ociqi7ujdq-lz.a.run.app",
  pdf_conversion_url: "https://pdf-konv-beta-ociqi7ujdq-lz.a.run.app",
  viva: "demo",
  firebase: {
    apiKey: "AIzaSyBK2HW3Sfu9VXXayuAqCFMzi1WZ0FdYE2w",
    authDomain: "collins-web-staging.firebaseapp.com",
    databaseURL: "https://collins-web-staging.firebaseio.com",
    projectId: "collins-web-staging",
    storageBucket: "collins-web-staging.appspot.com",
    messagingSenderId: "694239648050",
    appId: "1:694239648050:web:099d2953ec618ae0cc5f2b"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
